import Headroom from "headroom.js";

// select your header or whatever element you wish
const header = document.querySelector(".js-el__header");

export const headroom = new Headroom(header, {tolerance : 5});
headroom.init();

